<template>
  <v-row class="custom-grey-border" :class="{ 'ml-0': !vShowCalendar }">
    <v-col md="12" class="light-gray-background custom-border-bottom d-flex justify-space-between">
      <div style="font-size: 19px" class="text-uppercase font-weight-700 color-custom-blue">
        Team ({{ assignedTeam?.length }})
      </div>

      <div>
        <v-btn v-if="availableTeam.length" class="mx-2 custom-bold-button white--text" color="cyan" right small
          depressed @click="openEngineerDialog()">
          <v-icon class="mr-2">mdi-account-group</v-icon>Assign
        </v-btn>
        <v-btn v-else class="mx-2 custom-bold-button white--text" color="cyan" right small v-on:click="getEngineers()"
          depressed :disabled="jobLoading">
          <v-icon class="mr-2">mdi-account-group</v-icon>Get Available
        </v-btn>
      </div>
    </v-col>
    <v-col md="12">
      <v-row>
        <v-col v-if="assignedTeamObject.length > 0" md="12" class="pa-0">
          <v-list-item v-for="(row, index) in assignedTeamObject" :key="index"
            class="border-bottom rounded px-2 mb-2 grey lighten-4">
            <v-list-item-avatar class="my-1">
              <v-img :lazy-src="$defaultProfileImage" :src="row.engineer_profile_logo"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-size-14 font-weight-500">
                {{ row.engineer_display_name }}
                <template v-if="row.mark_as_tl">
                  <v-chip label small color="blue" outlined class="ml-2">
                    Team Lead
                  </v-chip>
                </template>
              </v-list-item-title>
              <v-list-item-subtitle class="font-size-12 font-weight-500" v-if="row.engineer_designation">
                <v-chip label color="red" small outlined style="font-size: 10px">
                  {{ row?.engineer_designation }}
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon class="my-1" link>
              <v-btn v-on:click="removeEngineer(row.engineer_id)" icon color="red lighten-1">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-list-item-icon>
          </v-list-item>
        </v-col>
        <v-col v-else md="12">
          <p class="font-size-16">No users are currently assigned</p>
        </v-col>
      </v-row>
    </v-col>
    <Dialog :common-dialog="show_engineers" :dialog-width="900">
      <template v-slot:title>Team ({{ assignedTeam?.length }}) </template>
      <template v-slot:body>
        <v-container fluid class="py-0">
          <v-row>
            <v-col md="12" class="pt-0 custom-listing-table">
              <div class="d-flex">
                <!-- Search input filters instantly in frontend -->
                <v-text-field style="max-width: 300px" v-model.trim="search"
                  clearable dense filled flat placeholder="Search by name, role, etc."
                  hide-details solo color="cyan" class="mr-2"></v-text-field>

                <!-- Type Selector -->
                <v-autocomplete hide-details v-model.trim="type" class="mr-2" :items="typeList" dense flat filled
                  style="max-width: 250px" placeholder="Type" item-color="cyan" color="cyan" solo
                  @change="onTypeChange()" item-value="value" item-text="text">
                </v-autocomplete>

                <!-- Skill / Certificate / License selector -->
                <v-autocomplete hide-details v-model.trim="related_text" class="mr-2" :items="skillList" dense flat
                  filled style="max-width: 250px" placeholder="Select Skill/Cert" item-color="cyan" color="cyan" solo clearable
                  item-value="text" item-text="text">
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title v-html="'No Category(s) Found.'"></v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-list-item-action class="ma-0">
                      <v-chip style="height: 16px; width: 16px; padding: 0" :color="item.color">
                      </v-chip>
                    </v-list-item-action>
                    <v-list-item-content class="py-0">
                      <v-list-item-title class="text-capitalize font-weight-500 font-size-16">
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-action class="mr-0">
                      <v-chip style="height: 16px; width: 16px; padding: 0" :color="item.color">
                      </v-chip>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title class="text-capitalize font-weight-500 font-size-16">{{ item.text
                        }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </div>
            </v-col>
            <v-col md="12" class="pt-0 custom-listing-table">
              <v-simple-table class="inner-simple-table" fixed-header>
                <template v-slot:default>
                  <thead style="
                      background-color: rgb(243, 246, 249);
                      color: rgb(36, 50, 109);
                    ">
                    <tr class="custom-border-bottom">
                      <td class="font-size-16 font-weight-700 p-0" width="15"></td>
                      <td class="font-size-16 font-weight-700 p-0">Name</td>
                      <td class="font-size-16 font-weight-700 p-0">Role</td>
                      <td class="font-size-16 font-weight-700 p-0">Skill</td>
                      <td class="font-size-16 font-weight-700 p-0">Certificates</td>
                      <td class="font-size-16 font-weight-700 p-0">Licenses</td>
                      <td class="font-size-16 font-weight-700 p-0" width="75">Mark As TL</td>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Iterate over filteredTeam instead of availableTeam -->
                    <template v-if="filteredTeam.length > 0">
                      <tr v-for="(row, index) in filteredTeam" :key="index"
                        :class="{ 'orange_lighten-5': index % 2 == 0 }">
                        <td class="p-0">
                          <v-checkbox :input-value="assignedTeam" :key="assignedTeam.join('-') + '-' + row.engineer_id"
                            :placeholder="row.engineer_display_name" :value="String(row.engineer_id)" :disabled="row?.engineer_disabled == 1 ? true : false"
                            hide-details color="cyan" class="mr-4 mt-0" v-on:change="toggleEngineer(row.engineer_id)"
                            multiple></v-checkbox>
                        </td>
                        <td class="p-0">
                          <div class="d-flex">
                            <div class="mr-1">
                              <v-avatar size="35">
                                <v-img class="customer-image white-background" width="35" height="35"
                                  :lazy-src="$defaultProfileImage" :src="row.engineer_profile_logo
                                      ? row.engineer_profile_logo
                                      : $defaultProfileImage
                                    ">
                                </v-img>
                              </v-avatar>
                            </div>
                            <div>
                              <span class="font-weight-700 text-capitalize">{{
                                row?.engineer_display_name
                              }}</span>
                              <span v-if="row?.engineer_disabled == 1">
                                <v-chip label small color="red" class="text-white ml-1">Unavailable</v-chip></span>
                              <div>
                                <v-chip label color="red" small outlined style="font-size: 10px">
                                  {{ row?.engineer_designation }}
                                </v-chip>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="p-0">
                          <template v-if="row && row.engineer_role == 2">
                            <span class="font-weight-700">Technician</span>
                          </template>
                        </td>
                        <td class="p-0">
                          <template v-if="row?.all_skills?.length > 0">
                            <v-chip v-if="row?.all_skills[0]?.certificate_name" small :color="row?.all_skills[0]?.color"
                              label outlined :text-color="row?.all_skills[0]?.color ? '' : 'black'">
                              {{ row?.all_skills[0]?.certificate_name }}
                            </v-chip>
                            <div class="mt-2">
                              <v-chip v-if="row?.all_skills[1]?.certificate_name" small
                                :color="row?.all_skills[1]?.color" label outlined :text-color="row?.all_skills[1]?.color ? '' : 'black'">
                                {{ row?.all_skills[1]?.certificate_name }}
                              </v-chip>
                            </div>
                            <template v-if="row?.all_skills?.length > 1">
                              <v-chip small color="blue white--text" label class="ml-1 mt-1">
                                <span class="font-size-16 font-weight-500">
                                  <template v-if="row?.all_skills?.length == 2">
                                    +{{ row?.all_skills?.length - 1 }} More
                                  </template>
                                  <template v-if="row?.all_skills?.length > 2">
                                    +{{ row?.all_skills?.length - 2 }} More
                                  </template>
                                </span>
                              </v-chip>
                            </template>
                          </template>
                          <em v-else class="text-muted"> no skills </em>
                        </td>
                        <td class="p-0">
                          <template v-if="row?.all_certificates?.length > 0">
                            <v-chip v-if="row?.all_certificates[0]?.certificate_name" small
                              :color="row?.all_certificates[0]?.color" label outlined :text-color="row?.all_certificates[0]?.color ? '' : 'black'">
                              {{ row?.all_certificates[0]?.certificate_name }}
                            </v-chip>
                            <div class="mt-2">
                              <v-chip v-if="row?.all_certificates[1]?.certificate_name" small :color="row?.all_certificates[1]?.color" label outlined :text-color="row?.all_certificates[1]?.color ? '' : 'black'">
                                {{ row?.all_certificates[1]?.certificate_name }}
                              </v-chip>
                            </div>
                            <template v-if="row?.all_certificates?.length > 1">
                              <v-chip small color="blue white--text" label class="ml-1 mt-1">
                                <span class="font-size-16 font-weight-500">
                                  <template v-if="row?.all_certificates?.length == 2">
                                    +{{ row?.all_certificates?.length - 1 }} More
                                  </template>
                                  <template v-if="row?.all_certificates?.length > 2">
                                    +{{ row?.all_certificates?.length - 2 }} More
                                  </template>
                                </span>
                              </v-chip>
                            </template>
                          </template>
                          <em v-else class="text-muted"> no certificates </em>
                        </td>
                        <td class="p-0">
                          <template v-if="row?.all_licenses?.length > 0">
                            <v-chip v-if="row?.all_licenses[0]?.certificate_name" small
                              :color="row?.all_licenses[0]?.color" label outlined :text-color="row?.all_licenses[0]?.color ? '' : 'black'">
                              {{ row?.all_licenses[0]?.certificate_name }}
                            </v-chip>
                            <div class="mt-2">
                              <v-chip v-if="row?.all_licenses[1]?.certificate_name" small
                                :color="row?.all_licenses[1]?.color" label outlined :text-color="row?.all_licenses[1]?.color ? '' : 'black'">
                                {{ row?.all_licenses[1]?.certificate_name }}
                              </v-chip>
                            </div>
                            <template v-if="row?.all_licenses?.length > 1">
                              <v-chip small color="blue white--text" label class="ml-1 mt-1">
                                <span class="font-size-16 font-weight-500">
                                  <template v-if="row?.all_licenses?.length == 2">
                                    +{{ row?.all_licenses?.length - 1 }} More
                                  </template>
                                  <template v-if="row?.all_licenses?.length > 2">
                                    +{{ row?.all_licenses?.length - 2 }} More
                                  </template>
                                </span>
                              </v-chip>
                            </template>
                          </template>
                          <em v-else class="text-muted"> no licenses </em>
                        </td>
                        <td class="p-0" width="75">
                          <v-checkbox :disabled="checkDisabled(row.engineer_id)" color="cyan" hide-details class="mt-0"
                            small :value="row.mark_as_tl" :input-value="row.mark_as_tl"
                            v-on:change="updateAssignedTeamObject(row, $event)"></v-checkbox>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td :colspan="7">
                          <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                            Sorry! No Team(s) Found.
                          </p>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn class="mx-2 custom-grey-border custom-bold-button" v-on:click="closeEngineer()">
          Close
        </v-btn>
        <v-btn class="custom-bold-button ml-4" depressed v-on:click="saveEngineer()"
          color="cyan white--text">Save</v-btn>
      </template>
    </Dialog>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { GET } from "@/core/services/store/request.module";
import {
  REMOVE_ENGINEER,
  GET_AVAILABLE_ENGINEER,
  UPDATE_SCHEDULE_STATE,
  UPDATE_SCHEDULE_ENGINEER,
} from "@/core/services/store/job.module";
import moment from "moment-timezone";
import Dialog from "@/view/pages/partials/Dialog.vue";
import { find } from "lodash";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "job-ctx-schedule-team",
  data() {
    return {
      show_engineers: false,
      visitId: 0,
      ticketId: 0,
      search: null,
      type: "all",
      related_text: null,
      skillList: [],
      typeList: [
        { value: "all", text: "All" },
        { value: "skill", text: "Skill" },
        { value: "certificate", text: "Certificate" },
        { value: "license", text: "Licences" },
      ],
      previousAssignedTeam: [],
      previousAssignedTeamObject: [],
      hasCheckedInitialAvailability: false,
      scheduleOutputDebounce: null,
    };
  },
  methods: {
    openEngineerDialog() {
      this.previousAssignedTeam = [...this.assignedTeam];
      this.previousAssignedTeamObject = [...this.assignedTeamObject];
      this.show_engineers = true;
    },

    toggleEngineer(engineerId) {
      let selected = new Set((this.assignedTeam || []).map(String));
      const id = String(engineerId);

      const engineer = this.availableTeam.find(e =>
        String(e.engineer_id) === id
      );

      if (!engineer) return;

      if (selected.has(id)) {
        selected.delete(id);
      } else {
        selected.add(id);

        const teamIds = engineer.team_ids || [];

        this.availableTeam.forEach(e => {
          if (!e.team_ids) return;
          if (e.engineer_disabled == 1) return;

          const sameTeam = e.team_ids.some(tid =>
            teamIds.includes(tid)
          );

          if (sameTeam) {
            selected.add(String(e.engineer_id));
          }
        });
      }

      this.updateScheduleState('dbAssignedTeam', [...selected]);
    },

    checkDisabled(id) {
      if (find(this.assignedTeam, (row) => row == id)) {
        return false;
      }
      return true;
    },

    closeEngineer() {
      let key = "dbAssignedTeam";
      let value = this.previousAssignedTeam;
      let statekey = "dbAssignedTeamObject";
      let stateValue = this.previousAssignedTeamObject;
      this.$store.commit(UPDATE_SCHEDULE_STATE, { key, value });
      this.$store.commit(UPDATE_SCHEDULE_STATE, { statekey, stateValue });
      this.$store.commit(UPDATE_SCHEDULE_ENGINEER);

      this.search = null;
      this.type = "all";
      this.related_text = null;
      this.show_engineers = false;
    },

    saveEngineer() {
      this.search = null;
      this.type = "all";
      this.related_text = null;
      this.show_engineers = false;
    },

    updateScheduleState(key, value) {
      this.teamUpdate = true;
      this.$store.commit(UPDATE_SCHEDULE_STATE, { key, value });
      this.$store.commit(UPDATE_SCHEDULE_ENGINEER);
    },

    updateAssignedTeamObject(value, event) {
      let flagValue = !!event;

      if (this.assignedTeamObject && this.assignedTeamObject.length > 0) {
        for (let i = this.assignedTeamObject.length - 1; i >= 0; i--) {
          this.assignedTeamObject[i].mark_as_tl =
            this.assignedTeamObject[i].engineer_id == value.engineer_id ? flagValue : false;
        }
      }

      if (this.availableTeam && this.availableTeam.length > 0) {
        for (let i = this.availableTeam.length - 1; i >= 0; i--) {
          this.availableTeam[i].mark_as_tl =
            this.availableTeam[i].engineer_id == value.engineer_id ? flagValue : false;
        }
      }

      let statekey = "dbAssignedTeamObject";
      this.$store.commit(UPDATE_SCHEDULE_STATE, { statekey, value });
    },

    removeEngineer(id) {
      this.$store.commit(REMOVE_ENGINEER, id);
    },

    onTypeChange() {
      this.related_text = null;
      this.getRelatedSkill();
    },

    getRelatedSkill() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: `related-skill/${this.type}`,
        })
        .then(({ data }) => {
          _this.skillList = data;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getEngineers() {
      let schedule = {};

      if (this.scheduleType == "one-off") {
        schedule = this.oneOffSchedule;
      } else if (this.scheduleType == "recurring") {
        schedule =
          Array.isArray(this.scheduleOutput) && this.scheduleOutput.length
            ? this.scheduleOutput[0]
            : this.recurringSchedule;
      } else {
        schedule = this.schedule;
      }

      // Fetch all available engineers without search/filter parameters
      this.$store.dispatch(GET_AVAILABLE_ENGINEER, {
        search: "",
        related_text: "",
        type: "",
        start_date: moment(schedule.startDate || schedule.start_date).format("YYYY-MM-DD"),
        start_time: moment(
          `${schedule.startDate || schedule.start_date} ${schedule.startTime || schedule.start_time}`
        ).format("HH:mm"),
        end_date: moment(schedule.endDate || schedule.end_date).format("YYYY-MM-DD"),
        end_time: moment(
          `${schedule.endDate || schedule.end_date} ${schedule.endTime || schedule.end_time}`
        ).format("HH:mm"),
        force: this.visitId && this.visitId > 0 ? 1 : 0,
        customer: this.vCustomerId,
        property: this.vPropertyId
      });
    },
  },
  computed: {
    ...mapGetters([
      "vShowCalendar",
      "oneOffSchedule",
      "recurringSchedule",
      "jobLoading",
      "availableTeam",
      "assignedTeam",
      "assignedTeamObject",
      "scheduleType",
      "scheduleOutput",
      "vCustomerId",
      "vPropertyId"
    ]),

    // Client-side computed filter
    filteredTeam() {
      if (!this.availableTeam || !Array.isArray(this.availableTeam)) {
        return [];
      }

      let list = this.availableTeam;

      // 1. Text Search Filter (name, barcode, designation)
      if (this.search && this.search.trim()) {
        const query = this.search.trim().toLowerCase();
        list = list.filter((row) => {
          const name = (row?.engineer_display_name || "").toLowerCase();
          const barcode = (row?.engineer_barcode || "").toLowerCase();
          const designation = (row?.engineer_designation || "").toLowerCase();

          return (
            name.includes(query) ||
            barcode.includes(query) ||
            designation.includes(query)
          );
        });
      }

      // 2. Skill / Certificate / License Filter
      if (
        this.related_text &&
        this.related_text.trim() &&
        this.related_text.toLowerCase() !== "all"
      ) {
        const target = this.related_text.trim().toLowerCase();

        const matchArray = (items) => {
          if (!Array.isArray(items)) return false;
          return items.some((item) => {
            const certName = (item?.certificate_name || item?.name || item?.text || "").toLowerCase();
            return certName === target || certName.includes(target);
          });
        };

        list = list.filter((row) => {
          if (this.type === "skill") {
            return matchArray(row.all_skills);
          } else if (this.type === "certificate") {
            return matchArray(row.all_certificates);
          } else if (this.type === "license") {
            return matchArray(row.all_licenses);
          } else {
            // 'all': matches across skills, certificates, or licenses
            return (
              matchArray(row.all_skills) ||
              matchArray(row.all_certificates) ||
              matchArray(row.all_licenses)
            );
          }
        });
      }

      return list;
    },
  },
  components: {
    Dialog,
  },
  created() {
    this.visitId = Number(this.$route?.query?.visit ?? 0);
    this.ticketId = Number(this.$route?.query?.ticket ?? 0);
  },
  mounted() {
    this.getRelatedSkill();
  },
  watch: {
    vCustomerId(param) {
      if (param) {
        this.getEngineers();
      }
    },

    oneOffSchedule: {
      deep: true,
      handler() {
        if (this.scheduleType === "one-off" && this.assignedTeam.length) {
          this.getEngineers();
        }
      },
    },

    scheduleOutput: {
      deep: true,
      handler() {
        if (
          this.scheduleType === "recurring" &&
          this.scheduleOutput.length &&
          this.assignedTeam.length
        ) {
          clearTimeout(this.scheduleOutputDebounce);
          this.scheduleOutputDebounce = setTimeout(() => {
            this.getEngineers();
          }, 250);
        }
      },
    },

    assignedTeam: {
      immediate: true,
      handler(newVal) {
        if (this.show_engineers) return;

        if (newVal && newVal.length && !this.hasCheckedInitialAvailability) {
          this.hasCheckedInitialAvailability = true;
          this.getEngineers();
        }
      },
    },

    availableTeam: {
      deep: true,
      handler(newList) {
        if (!newList || !newList.length) return;
        if (!this.assignedTeam || !this.assignedTeam.length) return;

        const availableIds = new Set(
          newList
            .filter((e) => e.engineer_disabled != 1)
            .map((e) => String(e.engineer_id))
        );

        [...this.assignedTeam].forEach((id) => {
          if (!availableIds.has(String(id))) {
            this.$store.commit(REMOVE_ENGINEER, id);
          }
        });
      },
    },
  },
};
</script>